import T from "prop-types";
import React from "react";
import { isEmpty } from "lodash";
import { Warning } from "MODULES/shared/components";

const FirstExchangeWarning = ({ lineItem }) => {
  if (!lineItem.exchange_sale) return null;
  if (isEmpty(lineItem.exchange_type)) return null;

  return (
    <Warning>
      Core Repair Invoice must be entered on the first exchange transaction for
      this item.
    </Warning>
  );
};

FirstExchangeWarning.propTypes = {
  lineItem: T.shape({})
};

export default FirstExchangeWarning;



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Panel/Billing/FirstExchangeWarning.jsx